var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-input',{attrs:{"id":_vm.id,"value":_vm.formatedDate,"placeholder":_vm.placeholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }